import { PENDING_TAB_PATH } from "./pending-tab-path";

interface PendingTabProps {
  /** Stroke color; white when selected, #999999 when inactive. */
  strokeColor?: string;
}

/**
 * Outline pending (asterisk) icon for header navigation tabs.
 *
 * @param strokeColor - Icon stroke color (defaults to white for active state)
 */
const PendingTab = ({ strokeColor = "white" }: PendingTabProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d={PENDING_TAB_PATH}
        stroke={strokeColor}
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PendingTab;
